import type { TooltipProps } from './tooltip';
import { Tooltip } from './tooltip';

export function Popover({ children, ...rest }: TooltipProps) {
  return (
    <Tooltip {...rest} isPopover>
      {children}
    </Tooltip>
  );
}
